import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { propTypes } from '../../util/types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';
import {
    LayoutSingleColumn,
    Modal,
    Page,
} from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import css from './TrackUserPage.module.css';
import TrackUserForm from './TrackUserForm';
import { parse } from '../../util/urlHelpers';
import { fetchTrackEventsFromMongo, fetchtrackUser, getGuestsUser } from './TrackUserPage.duck';
import { useState, useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import { formatPathName } from '../../util/routes';

export const TrackUserPageComponent = props => {
    const {
        intl,
        currentUser,
        scrollingDisabled,
        onManageDisableScrolling,
        trackUser,
        trackUsersInProgress,
        onfetchTrackEventsFromMongo,
        trackEvents,
        trackEventsInProgress,
        onfetchtrackUser,
        guestsUser,
        history,
        onfetchGuestsUser,
        guestsUsersInProgress,
        location,
    } = props;

    const config = useConfiguration();
    const title = intl.formatMessage({ id: 'TrackUserPage.title' }, { marketplaceName: config.marketplaceName });
    const [showReport, setShowReport] = useState(false);
    const [showPath, setShowPath] = useState(false)
    const [selectedSession, setSelectedSession] = useState(null);
    const [selectedRole, setSelectedRole] = useState("AuthenticatedUsers");

    useEffect(() => {
        const queryParams = parse(location.search);
        const page = parseInt(queryParams.page || 1, 10);
        const email = queryParams.email || '';

        if (selectedRole === 'AuthenticatedUsers') {
            onfetchtrackUser({ page, email });
        } else {
            onfetchGuestsUser({ page });
        }
    }, [location.search, selectedRole]);

    const handleShowReport = (userId,deviceId) => {
        setShowReport(true)
        onfetchTrackEventsFromMongo(userId,deviceId)
    }

    const MyLoader = () => (
        <ContentLoader height={220} width={"100%"}>
            <rect x="0" y="0" rx="4" ry="4" width="100%" height="20" />
            <rect x="0" y="30" rx="4" ry="4" width="100%" height="20" />
            <rect x="0" y="60" rx="4" ry="4" width="100%" height="20" />
            <rect x="0" y="90" rx="4" ry="4" width="100%" height="20" />
            <rect x="0" y="120" rx="4" ry="4" width="100%" height="20" />
            <rect x="0" y="150" rx="4" ry="4" width="800" height="20" />
        </ContentLoader>
    );

    const getDuration = session => {
        const start = new Date(session.startedAt);
        const end = new Date(session.lastActivityAt || session.endedAt);
        const seconds = Math.floor((end - start) / 1000);
        return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
    };


    const handleSubmit = (values) => {
        const email = values.email || '';
        const searchParams = new URLSearchParams(location.search);
        if (email) {
            searchParams.set('email', email);
            searchParams.delete('page'); // reset to first page on new search
        } else {
            searchParams.delete('email');
        }
        history.push({ search: searchParams.toString() });
    }

    return (
        <Page title={title} scrollingDisabled={scrollingDisabled} className={css.pageRoot}>
            <LayoutSingleColumn
            
                topbar={
                    <TopbarContainer
                        currentPage="TrackUserPage"
                        desktopClassName={css.desktopTopbar}
                        mobileClassName={css.mobileTopbar}
                    />
                }
                sideNav={null}
                currentUser={currentUser}
                currentPage="TrackUserPage"
                footer={<FooterContainer />}
            >
                <div     className={css.pageWrapper}>
                <h1 className={css.title}>
                    <FormattedMessage id="TrackUserPage.heading" />
                </h1>
                <TrackUserForm
                    trackUsers={trackUser}
                    handleSubmit={handleSubmit}
                    trackUsersInProgress={trackUsersInProgress}
                    onfetchTrackEventsFromMongo={onfetchTrackEventsFromMongo}
                    handleShowReport={handleShowReport}
                    onfetchtrackUser={onfetchtrackUser}
                    setSelectedRole={setSelectedRole}
                    selectedRole={selectedRole}
                    guestsUser={guestsUser}
                    history={history}
                    location={location}
                    onfetchGuestsUser={onfetchGuestsUser}
                    guestsUsersInProgress={guestsUsersInProgress}
                />

                <Modal
                    id="TrackUserPage.ReportModal"
                    isOpen={showReport}
                    onClose={() => setShowReport(false)}
                    usePortal
                    onManageDisableScrolling={onManageDisableScrolling}
                    className={css.showInterestModal}
                >
                    {trackEventsInProgress
                        ? <MyLoader />
                        :
                        <>
                            {
                                trackEvents?.data?.length === 0 ? "No data found" :
                                    (
                                        <div className={css.modalTableContainer}>
                                            <table className={css.transactionTable}>
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Started At</th>
                                                        <th>Ended At</th>
                                                        <th>Duration</th>
                                                        <th>Events</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        trackEvents?.data?.slice().sort((a, b) => new Date(b.startedAt) - new Date(a.startedAt)).map((e) => {
                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <td>{new Date(e?.startedAt).toLocaleDateString()}</td>
                                                                        <td>{new Date(e?.startedAt).toLocaleTimeString()}</td>
                                                                        <td>{new Date(e?.lastActivityAt).toLocaleTimeString()}</td>
                                                                        <td>{getDuration(e)}</td>
                                                                        <td>{e?.events?.length}</td>
                                                                        <td>
                                                                            <button className={css.viewPathButton}
                                                                                onClick={() => {
                                                                                    setSelectedSession(e);
                                                                                    setShowPath(true);
                                                                                }}
                                                                            >
                                                                                View Path
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )
                                                        })
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    )
                            }

                        </>
                    }
                </Modal>
                <Modal
                    id="TrackUserPage.pathModal"
                    isOpen={showPath}
                    onClose={() => {
                        setShowPath(false);
                        setSelectedSession(null);
                    }}
                    usePortal
                    onManageDisableScrolling={onManageDisableScrolling}
                    className={css.showInterestModal}
                >
                    {!selectedSession ? (
                        <p>No session selected</p>
                    ) : (
                        <>
                            <h3 className={css.sessionTitle}>
                                Session ID: {selectedSession._id.slice(0, 8)}
                            </h3>

                            <div className={css.modalTableContainer}>
                                <table className={css.transactionTable}>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Path</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedSession?.events?.map((ev, index) => (
                                            <tr key={index}>
                                                <td>{new Date(ev.time).toLocaleDateString()}</td>
                                                <td>{new Date(ev.time).toLocaleTimeString()}</td>
                                                <td className={css.pathCell}>
                                                    <div className={css.pageName}>{formatPathName(ev?.path)}</div>
                                                    <span className={css.rawPath}>{ev?.path}</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </Modal>
</div>
            </LayoutSingleColumn>
        </Page>
    );
};

TrackUserPageComponent.defaultProps = {
    currentUser: null,
};

const { bool, func, shape } = PropTypes;

TrackUserPageComponent.propTypes = {
    currentUser: propTypes.currentUser,
    scrollingDisabled: bool.isRequired,
    intl: intlShape.isRequired,
    history: shape({
        push: func.isRequired,
    }).isRequired,
};

const mapStateToProps = state => {
    const { currentUser } = state.user;
    const { trackUser, trackUsersInProgress, trackEvents, trackEventsInProgress, guestsUser, guestsUsersInProgress } = state.TrackUserPage;
    return {
        currentUser,
        trackUser,
        trackUsersInProgress,
        trackEvents,
        trackEventsInProgress,
        scrollingDisabled: isScrollingDisabled(state),
        guestsUser,
        guestsUsersInProgress
    };
};

const mapDispatchToProps = dispatch => ({
    onManageDisableScrolling: (componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling)),

    onfetchTrackEventsFromMongo: (params) => dispatch(fetchTrackEventsFromMongo(params)),

    onfetchtrackUser:params=>dispatch(fetchtrackUser(params)),

    onfetchGuestsUser: params => dispatch(getGuestsUser(params))
});

const TrackUserPage = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withRouter,
    injectIntl
)(TrackUserPageComponent);

export default TrackUserPage;
